// extracted by mini-css-extract-plugin
export default {"panelWrapper":"u4K4OKjSK2lyrU_K0Pms","listItemSpacing":"XzLRDmDdQ1czZkBNYJv3"};